import * as ApiModels from '@typings/api-models';
import CommentParticipants from '@/components/Message/CommentParticipants';
import pluralize from 'pluralize';
import s from './Message.module.scss';

type Props = {
  replies?: (Pick<ApiModels.Message, 'id'> & {
    owner: Pick<ApiModels.Person, 'id' | 'name'> & {
      primaryColour: { hex: string } | null;
      image: { url: string } | null;
    };
  })[];
  size: number;
};

const Participants: React.FC<Props> = ({ replies, size }) => {
  const uniqueReplies = replies?.filter((r, i, a) => a.findIndex(_r => _r.owner.id === r.owner.id) === i);

  return (
    <div className={s.participants}>
      <CommentParticipants userLogoSize={size} participants={uniqueReplies?.map(r => ({
        color: r.owner.primaryColour?.hex || null,
        id: r.owner.id,
        logo: r.owner.image?.url,
        name: r.owner.name,
      }))} noLabel borderColor='var(--color-gray-15)' />

      {replies && replies.length > 0 && (
        <span className='caption'>
          {replies.length} {pluralize('reply', replies.length)}
        </span>
      )}
    </div>
  );
};

export default Participants;
